import { withUI2FormContext } from 'shared-libs/components/ui2/forms/ui2-form/with-ui2-form-context'

import { UI2Form } from './forms/ui2-form/ui2-form'
import { UI2FormSection } from './forms/ui2-form-section/ui2-form-section'
import { UI2InputField } from './fields/ui2-input-field/ui2-input-field'
import { UI2TextAreaField } from './fields/ui2-text-area-field/ui2-text-area-field'
import { UI2SelectField } from './fields/ui2-select-field/ui2-select-field'
import { UI2DateTime } from './fields/ui2-date-time-field/ui2-date-time-field'
import { UI2PickerField } from './fields/ui2-picker-field/ui2-picker-field'
import { UI2QuantityField } from './fields/ui2-quantity-field/ui2-quantity-field'
import { UI2TemperatureField } from './fields/ui2-temperature-field/ui2-temperature-field'
import { UI2ScanField } from './fields/ui2-scan-field/ui2-scan-field'
import { UI2BarcodeDisplay } from './fields/ui2-barcode-display/ui2-barcode-display'
import { UI2QrCodeDisplay } from './fields/ui2-qr-code-display/ui2-qr-code-display'
import { UI2CheckboxField } from './fields/ui2-checkbox-field/ui2-checkbox-field'
import { UI2SwitchField } from './fields/ui2-switch-field/ui2-switch-field'
import { UI2RadioButtonField } from './fields/ui2-radio-button-field/ui2-radio-button-field'
import { UI2AddressField } from './fields/ui2-address-field/ui2-address-field'
import { UI2FileUploadField } from './fields/ui2-file-upload-field/ui2-file-upload-field'
import { UI2PhotoCaptureField } from './fields/ui2-photo-capture-field/ui2-photo-capture-field'
import { UI2DocumentCaptureField } from './fields/ui2-document-capture-field/ui2-document-capture-field'
import { UI2SensitiveFileField } from './fields/ui2-sensitive-file-field/ui2-sensitive-file-field'
import { UI2SignatureField } from './fields/ui2-signature-field/ui2-signature-field'
import { UI2ApiField } from './fields/ui2-api-field/ui2-api-field'
import { UI2EventField } from './fields/ui2-event-field/ui2-event-field'
import { UI2EntitySearchField } from './fields/ui2-entity-search-field/ui2-entity-search-field'
import { UI2ReviewField } from './fields/ui2-review-field/ui2-review-field'
import { UI2BlindMatchField } from './fields/ui2-blind-match-field/ui2-blind-match-field'
import { UI2FormulaField } from './fields/ui2-formula-field/ui2-formula-field'
import { UI2GeolocationField } from './fields/ui2-geolocation-field/ui2-geolocation-field'
import { UI2Banner } from './display/ui2-banner/ui2-banner'
import { UI2Icon } from './display/ui2-icon/ui2-icon'
import { UI2EntityPreviewCard } from './display/ui2-entity-preview-card/ui2-entity-preview-card'
import { UI2Text } from './display/ui2-text/ui2-text'
import { FormFocusTargetProvider } from './behavior/form-focus-target-provider'

// Registry keys use the 'ui:ui2:' schema prefix — matched by the entity renderer's ComponentsMap.
export default {
  UI2Form,
  UI2FormSection: withUI2FormContext(UI2FormSection),
  UI2InputField: withUI2FormContext(UI2InputField),
  UI2TextAreaField: withUI2FormContext(UI2TextAreaField),
  UI2SelectField: withUI2FormContext(UI2SelectField),
  UI2DateTimeField: withUI2FormContext(UI2DateTime),
  UI2PickerField: withUI2FormContext(UI2PickerField),
  UI2QuantityField: withUI2FormContext(UI2QuantityField),
  UI2TemperatureField: withUI2FormContext(UI2TemperatureField),
  UI2ScanField: withUI2FormContext(UI2ScanField),
  UI2BarcodeDisplay,
  UI2QrCodeDisplay,
  UI2CheckboxField: withUI2FormContext(UI2CheckboxField),
  UI2SwitchField: withUI2FormContext(UI2SwitchField),
  UI2RadioButtonField: withUI2FormContext(UI2RadioButtonField),
  UI2AddressField: withUI2FormContext(UI2AddressField),
  UI2FileUploadField: withUI2FormContext(UI2FileUploadField),
  UI2PhotoCaptureField: withUI2FormContext(UI2PhotoCaptureField),
  UI2DocumentCaptureField: withUI2FormContext(UI2DocumentCaptureField),
  UI2SensitiveFileField: withUI2FormContext(UI2SensitiveFileField),
  UI2SignatureField: withUI2FormContext(UI2SignatureField),
  UI2ApiField: withUI2FormContext(UI2ApiField),
  UI2EventField: withUI2FormContext(UI2EventField),
  UI2EntitySearchField: withUI2FormContext(UI2EntitySearchField),
  UI2ReviewField: withUI2FormContext(UI2ReviewField),
  UI2BlindMatchField: withUI2FormContext(UI2BlindMatchField),
  UI2FormulaField: withUI2FormContext(UI2FormulaField),
  UI2GeolocationField: withUI2FormContext(UI2GeolocationField),
  UI2Banner,
  UI2Icon,
  UI2EntityPreviewCard,
  UI2Text,
  FormFocusTargetProvider,
}

